<template>
  <div class="updatSeting">
    <el-row>
      <div class="model-header setting">
        <h2>Config Home</h2>
      </div>
    </el-row>
    <el-row :gutter="10">
      <div class="model-content">
        <el-col :span="8">
          <div class="d-flex flex-column">
            <div v-for="home_menu_1 in homeMenu[0]" :key="home_menu_1.key" class="d-flex">
              <el-input placeholder="Tên" v-model="home_menu_1.name" clearable class="input-seach" style="margin-right: 5px;"></el-input>
              <el-input placeholder="Link" v-model="home_menu_1.link" clearable class="input-seach"></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="d-flex flex-column">
            <div v-for="home_menu_2 in homeMenu[1]" :key="home_menu_2.key" class="d-flex">
              <el-input placeholder="Tên" v-model="home_menu_2.name" clearable class="input-seach" style="margin-right: 5px;"></el-input>
              <el-input placeholder="Link" v-model="home_menu_2.link" clearable class="input-seach"></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="d-flex flex-column">
            <div v-for="home_menu_3 in homeMenu[2]" :key="home_menu_3.key" class="d-flex">
              <el-input placeholder="Tên" v-model="home_menu_3.name" clearable class="input-seach" style="margin-right: 5px;"></el-input>
              <el-input placeholder="Link" v-model="home_menu_3.link" clearable class="input-seach"></el-input>
            </div>
          </div>
        </el-col>
      </div>
    </el-row>
    <div style="padding-top: 20px">
      <el-button
        :disable="!canSubmit"
        :loading="!canSubmit"
        type="warning"
        size="small"
        @click="updateModelHomeMenu()">Cập nhật</el-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import tinymce from 'vue-tinymce-editor'
import ls from 'local-storage'
export default {
  name: 'Config Home Menu',
  components: {
    tinymce
  },
  metaInfo () {
    return {
      title: 'Config Home'
    }
  },
  data () {
    return {
      canSubmit: true,
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link image media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      homeMenu: [],
      image: '',
      image_path: '',
      upload: {
        uploadProcess: false,
        url: process.env.API_URI + 'configs/upload',
        url_not_resize: process.env.API_URI + 'configs/upload-not-resize',
        headers: {
          Authorization: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModelHomeMenu()
    this.configUpload()
  },
  methods: {
    handleImageAdded: async function (file, success, failure) {
      // images_upload_handler: handleImageAdded // Vứt vào đoạn option cạnh chữ 500px
      let formData = new FormData()
      formData.append('file', file.blob())
      let response = await axios.post('configs/upload-not-resize', formData)
      if (response.code === 1) {
        success(response.data.path_sm)
      } else {
        return false
      }
    },
    getImage (data) {
      return process.env.IMAGE_URL + 'storage/images/configs/' + data
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'configs-home', text: 'Config Home' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'home-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModelHomeMenu () {
      this.canSubmit = false
      axios.get('configs/home-menu').then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.homeMenu = response.data.value
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    updateModelHomeMenu (formName) {
      this.canSubmit = false
      let data = {
        'key': 'home-menu',
        'value': this.homeMenu
      }
      axios.put('configs/1', data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    fetchListCode () {
      axios.get('settings/1').then(response => {
        switch (response.code) {
          case 200:
            this.lists.listCode = response.data.guide_buy2
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    removeDomainDefault (item) {
      var index = this.modelData.linkAndBanner.images.indexOf(item)
      if (index !== -1) {
        this.modelData.linkAndBanner.images.splice(index, 1)
      }
    },
    addImage () {
      this.modelData.linkAndBanner.images.push({
        'key': Math.floor(Math.random() * 100000) + 1,
        'name': 'Sàn lát 1',
        'name_en': 'Paving floors 1',
        'name_es': '포장 바닥 1',
        'image': '',
        'desscription': ''
      })
    },

    // Upload Ảnh
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh trường có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleAvatarSuccess (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.image = response.data.name
        this.image_path = response.data.path_sm
      }
    },
    handleAvatarProcess (event, file, fileList) {
      this.upload.uploadProcess = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.huhu {
  margin-top: 10px;
}
.line {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
}
.line input {
  margin-right: 10px;
}
.image-preview {
  height: 50px;
  width: 50px;
  margin-right: 10px;
}
</style>
<style type="text/css">
.updatSeting .course-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}
.course-uploader .el-upload:hover {
  border-color: #409EFF;
}
.updatSeting .course-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 180px;
  height: 100px;
  line-height: 100px !important;
  text-align: center;
}

.updatSeting .courseSettig {
  width: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/config-home/Update.vue